import { Route, Routes } from 'react-router-dom';
import { ReportsList, ReportDetail } from './components';

export const ReportingPage = () => (
  <Routes>
    <Route
      index
      element={<ReportsList />}
    />
    <Route
      path=":id"
      element={<ReportDetail />}
    />
  </Routes>
);
